import {
    ISSUE,
    ISSUEV2,
    ISSUE_SUCCESS,
    ISSUE_ERROR,
    ADD_ISSUE,
    ADD_ISSUE_SUCCESS,
    ADD_ISSUE_ERROR,
    UPDATE_ISSUE,
    UPDATE_ISSUE_SUCCESS,
    UPDATE_ISSUE_ERROR,
    DELETE_ISSUE,
    DELETE_ISSUE_SUCCESS,
    DELETE_ISSUE_ERROR,
    ISSUE_ITEMS,
    ISSUE_ITEMS_SUCCESS,
    ISSUE_ITEMS_ERROR
} from "../constants/issueConstant";

const initialState = {
    loading: false,
    success: false,
    error: '',
    itemsIssues:[],
    type: '',
    loadingTitle: '',
    loadingMessage: ''
};

function issueReducer(state = initialState, action) {
    switch (action.type) {
        case ISSUEV2:
            const oldIssues = state.issueData.filter(issue => !action.data.some(newIssue => newIssue._id === issue._id));
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'issueData': oldIssues.concat(action.data),
                'type': action.type
            });
        case ISSUE:

            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ISSUE',
                'loadingMessage': 'THE ISSUES ARE BEING LOADED',
                'type': action.type
            });
        case ISSUE_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case ISSUE_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'issueData': action.data,
                'type': action.type
            });
        case ISSUE_ITEMS:

            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ISSUE',
                'loadingMessage': 'THE ISSUES ARE BEING LOADED',
                'type': action.type
            });
        case ISSUE_ITEMS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case ISSUE_ITEMS_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'itemsIssues': action.data,
                'type': action.type
            });
        case ADD_ISSUE:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ISSUE',
                'loadingMessage': 'THE ISSUE IS BEING SAVED',
                'type': action.type
            });
        case ADD_ISSUE_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case ADD_ISSUE_SUCCESS:

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'issueData': [...state.issueData, action.data],
                'type': action.type
            });
        case UPDATE_ISSUE:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ISSUE',
                'loadingMessage': 'THE ISSUE IS BEING UPDATED',
                'type': action.type
            });
        case UPDATE_ISSUE_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case UPDATE_ISSUE_SUCCESS:

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'issueData': state.issueData? state.issueData.map(
                    i => ( i._id === action.data._id ) ? action.data : i
                ) : [...action.data],
                'type': action.type

            });
        case DELETE_ISSUE:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ISSUE',
                'loadingMessage': 'THE ISSUE IS BEING DELETED',
                'type': action.type
            });
        case DELETE_ISSUE_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case DELETE_ISSUE_SUCCESS:

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'issueData': state.issueData.filter(issue => issue._id !== action.data),
                'type': action.type

            });
        default:
            return state;
    }
}

export default issueReducer;

